<template>
    <div>
        <van-nav-bar
            title="质保书查询"
            left-text=""
            right-text=""
            left-arrow
            fixed
            @click-left="back()"
            v-if="show"
            z-index="9999"
        />
        <van-sticky>
            <van-search
                    class="searchwarp"
                    v-model="value"
                    placeholder="单号\货主提单号"
                    @blur="onSearch"
                    show-action
            >
                <template #action>

                    <div @click="openScan()"><van-icon name="scan" :size="28" style="margin-top:10px"/></div>
                </template>
            </van-search>
        </van-sticky>



        <div class="contentwarp">
            <!-- 搜索提示 -->
            <van-empty v-if="list.length==0" image="search" description="质保书查询" />
            <van-grid v-if="list.length>0" :border="true" :column-num="3">
                <van-grid-item v-for="item in list" :key="item.id">
                    <van-image width="100" height="100" lazy-load :src="item" @click="showImg(item)"/>
                </van-grid-item>

            </van-grid>
        </div>




        <van-popup v-model="showpop" position="right" :style="{ height: '100%', width:'80%'}" >
            <div class="editwarp">
                <van-field v-model="carInfo.carNum" label="车牌号码"  placeholder="请输入车牌号码"  autocomplete="off"/>
                <van-field v-model="carInfo.dirver" label="驾驶员姓名"  placeholder="请输入驾驶员姓名"  autocomplete="off"/>
                <van-field v-model="carInfo.phone" label="手机号码"  placeholder="请输入手机号码"  autocomplete="off"/>
                <van-button  block size="small" type="info" native-type="submit" style="font-size: 16px" @click="saveFleet()">
                    保存
                </van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {NavBar, Cell, Button, Icon, Field} from 'vant';
    import {Toast } from 'vant';
    import {List } from 'vant';
    import {Search  } from 'vant';
    import { Col, Row } from 'vant';
    import {SwipeCell } from 'vant';
    import {Popup } from 'vant';
    import {PullRefresh } from 'vant';
    import {Sticky } from 'vant';
    import { Empty } from 'vant';
    import { Image as VanImage } from 'vant';
    import { ImagePreview } from 'vant';
    import { Grid, GridItem } from 'vant';
    import wx from 'weixin-js-sdk';
    import service from '../../server/index'


    export default {
        name: "WarrantyBook",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row .name]: Row ,
            [Cell.name]: Cell,
            [SwipeCell.name ]:SwipeCell,
            [Button.name]:Button,
            [Popup.name]: Popup,
            [Icon.name]:Icon,
            [Field.name]:Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [Empty.name]: Empty,
            [VanImage.name]:VanImage,
            [ImagePreview.Component.name]:ImagePreview.Component,
            [Grid.name]:Grid,
            [GridItem.name]:GridItem
        },
        data(){
          return {
              value:"",
              show:true,//nav bar
              list: [

                  ],
              loading:true,
              finished: false,
              showpop:false,
              //编辑车辆
              carInfo:{
                  "id":"",
                  "carNum":"",
                  "dirver":"",
                  "phone":""
              },
              //刷新
              isLoading:false,
              page:1,

          }
        },
        mounted() {
            // this.onLoad();
        },
        methods:{
            back(){
                this.$router.replace("/Home/Search")
            },
            onSearch(){
                this.list = [];
                this.page = 1;
                this.onLoad();
            },
            onLoad(){

                let param = {
                    keywords:this.value,
                    deliveryName:localStorage.getItem("personName"),
                    deliveryIdnumber:localStorage.getItem("deliveryIdnumber"),
                }

                service.getWarrantyBookList(param).then((res)=>{
                    if(res.code=="200"){
                        if(res.data.length>0){
                            this.list = res.data
                            this.page++
                        }else{
                            Toast("未查询到相关质保书")
                        }
                    }else{
                        Toast(res.message)
                    }

                }).catch((res)=>{
                    Toast(res.message)
                });
            },
            onRefresh(){
                this.onLoad();

            },
            showImg(item){
                ImagePreview([item]);
            },
            openScan () {
                let params = {
                    url: window.location.href.split("#")[0],
                    appName:process.env.VUE_APP_NAME,
                    ouid:process.env.VUE_APP_WECHAT_OUID
                }
                service.getWxconfig(params).then((res)=>{
                   // alert(JSON.stringify(res));
                   if(res.code==200){
                       wx.config({
                           debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                           appId: res.data.appId, // 必填，公众号的唯一标识
                           timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                           nonceStr: res.data.noncestr, // 必填，生成签名的随机串
                           signature: res.data.signature,// 必填，签名
                           jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
                       });

                       wx.scanQRCode({
                           needResult: 1,
                           desc: '扫描纸质提单二维码',
                           success: (res) =>{
                               // alert(res.resultStr);
                               this.value = res.resultStr.replace("CODE_128,","");
                               this.onLoad();
                           }
                       });
                   }
                }).catch((res)=>{
                    console.log(res);
                });

            },
            wxSdk(){


            }
        }
    }
</script>

<style scoped>
    .searchwarp{
        margin-top: 40px;
    }
    .editwarp{
        width:90%;
        margin: 50px auto;
    }

    .swipewarp{
        height: 44px;
    }

    .contentwarp{
        height: calc(100vh - 200px);
    }

    /*/deep/ .van-ellipsis{*/
    /*    color: #EE0A24;*/
    /*}*/
    /*/deep/ .van-nav-bar .van-icon{*/
    /*    color: #EE0A24;*/
    /*}*/

    /*/deep/ .van-nav-bar__text{*/
    /*    color: #EE0A24;*/
    /*}*/
</style>
